import MainPageService from "./MainPageService";
import $ from "jquery";
import {MAX_MOBILE_WIDTH, MOBILE_DEVICE_REGEXP} from "../../constans";
import gsap from "../../helpers/gsapInstance";
import Callback = gsap.Callback;

export default class MainPageCommonService {
    public readonly $body: JQuery;

    public readonly HEADER_WHITE_HEADER_CLASS: string = "white-header";
    public readonly HEADER_MAIN_PAGE_CLASS: string = "main-page";
    public readonly HIDDEN_CLASS: string = "overflow-hidden";
    public readonly ACTIVE_CLASS: string = "active";

    public isMobileDevice: boolean = false;

    // Время анимации в секундах для всех анимаций и переходов
    public readonly ANIMATION_DURATION_IN_SECONDS: number = 1;
    public readonly QUARTER_ANIMATION_DURATION: number = this.ANIMATION_DURATION_IN_SECONDS / 4;
    public readonly ONE_FIFTH_ANIMATION_DURATION: number = this.ANIMATION_DURATION_IN_SECONDS / 5;

    public readonly DEFAULT_HEADER_HEIGHT_DESKTOP: number = 88;
    public headerHeight: number = this.DEFAULT_HEADER_HEIGHT_DESKTOP;
    public viewportHeight: number;
    public headerHeightInPercentsFromViewport: number;

    constructor() {
        this.$body = $("body");

        this.detectMobileDevice = this.detectMobileDevice.bind(this);
        this.setHeightCharacteristics = this.setHeightCharacteristics.bind(this);
    }

    /**
     * Проверить и дать boolean результат, мобильное ли устройство используется, или нет
     * @public
     */
    public detectMobileDevice(): boolean {
        //TODO, IMMEDIATELY: как пойдет все в прод и мы прекратим тест, убрать эту заглушку. Сейчас мы мерим по ширине экрана, а надо по самому устройству проверять
        const MAX_TABLET_VIEWPORT = 1023;
        return window.screen.width <= MAX_TABLET_VIEWPORT;

        // const isMobileDeviceDetected = MOBILE_DEVICE_REGEXP.test(navigator.userAgent);
        // this.isMobileDevice = isMobileDeviceDetected;
        // return isMobileDeviceDetected;
    }

    /**
     * Проверить, это мобильный телефон или планшет/десктоп
     * @public
     */
    public isMobilePhone(): boolean {
       return window.innerWidth <= MAX_MOBILE_WIDTH;
    }

    /**
     * Обновить характеристики высоты хедера и viewport при resize
     * @public
     */
    public setHeightCharacteristics(): void {
        this.headerHeight = MainPageService.getConvertedValue(this.DEFAULT_HEADER_HEIGHT_DESKTOP);
        this.viewportHeight = window.innerHeight;
        this.headerHeightInPercentsFromViewport = (this.headerHeight * 100) / this.viewportHeight;
    }

    /**
     * Скролл на самый верх, с добавлением duration и callback'ом после завершения
     * @public
     */
    public scrollToTop(duration: number = 0.2, onComplete?: Callback): void {
        gsap.to(window, {
            scrollTo: {
                y: 0,
                autoKill: false,
            },
            duration,
            onComplete
        });
    }
}
